{
  "title": "Facturación",
  "notVisibleTitle": "La facturación no es visible para ti",
  "notVisibleBody": "Los detalles de suscripción se muestran a administradores de inquilino y superiores.",
  "loadError": "No se pudo cargar la facturación",
  "notConnectedTitle": "La facturación no está conectada",
  "notConnectedBody": "Este entorno no tiene credenciales de Stripe. Configure Stripe:SecretKey y al menos un Price id en la API para habilitar suscripciones.",
  "checkoutCompleteTitle": "Pago completado",
  "checkoutCompleteBody": "Esperando a que Stripe confirme la suscripción…",
  "checkoutCompleteToast": "Pago completado. Stripe está confirmando la suscripción.",
  "checkoutCancelledToast": "Se canceló el pago. No se ha cobrado nada.",
  "noSubscriptionTitle": "Sin suscripción",
  "noSubscriptionBody": "Este inquilino aún no se factura. Una suscripción cobra un asiento por cada buzón que la plataforma estampa.",
  "noSubscriptionConfirming": "Stripe está confirmando la suscripción. Esta página se actualiza sola en cuanto lo haga.",
  "startSubscription": "Iniciar una suscripción",
  "setupBilling": "Configurar facturación",
  "subscription": "Suscripción",
  "plan": "Plan",
  "seats": "Asientos",
  "billedSeats": "Asientos facturados",
  "liveSeats": "Asientos en vivo",
  "seatsValue": "facturados {{billed}} / actuales {{current}}",
  "outOfSync": "desincronizados",
  "syncSeats": "Sincronizar asientos",
  "seatsSynced": "Asientos sincronizados: facturación {{count}}.",
  "seatSyncFailed": "Falló la sincronización de asientos.",
  "openPortal": "Abrir portal del cliente",
  "manageInStripe": "Gestionar facturación en Stripe",
  "portalOpenFailed": "No se pudo abrir el portal de facturación.",
  "cancelAtPeriodEnd": "Cancelar al final del periodo",
  "resume": "Reanudar",
  "resumeSubscription": "Reanudar suscripción",
  "collectionCard": "Tarjeta — cargo automático",
  "collectionInvoice": "Factura — enviada con plazos netos",
  "collectionInvoiceNet": "Factura — enviada con plazos netos (neto {{days}} días)",
  "statusNone": "Sin suscripción",
  "statusIncomplete": "Incompleta",
  "statusExpired": "Caducada",
  "statusTrialing": "En prueba",
  "statusActive": "Activa",
  "statusPastDue": "Vencida",
  "statusCanceled": "Cancelada",
  "statusUnpaid": "Impagada",
  "statusPaused": "En pausa",
  "setupTitle": "Configurar facturación",
  "setupIntro": "Los paquetes siguen el esquema Starter / Standard / Pro de Exclaimer. Un asiento por buzón que este inquilino hace estampar a la plataforma — {{seats}} hoy{{minimum}}; el recuento se concilia cada noche y los cambios se facturan en la siguiente factura.",
  "setupMinimumSuffix": ", facturado al mínimo de {{minimum}} asientos",
  "periodMonthly": "Mensual",
  "periodAnnual": "Anual",
  "billedAnnually": "Facturación anual",
  "billedAnnuallySave": "Facturación anual (ahorra {{percent}}%)",
  "billedMonthly": "Facturación mensual",
  "savePercent": "Ahorra {{percent}}%",
  "planSeatRate": "{{name}} ({{rate}}/asiento/mes)",
  "planStarter": "Starter",
  "planStandard": "Standard",
  "planPro": "Pro",
  "enterpriseAvailable": " Enterprise (presupuesto a medida) disponible a través de ventas.",
  "licensedBlocks": "Licenciado en bloques desde {{minimum}} asientos: un inquilino más pequeño se factura por {{minimum}}. ",
  "noTrialReturning": "Este inquilino ya se suscribió antes, así que no hay periodo de prueba.",
  "trialDays": "Los primeros {{days}} días son gratis; la primera factura se emite al terminar la prueba.",
  "payByCard": "Pagar con tarjeta",
  "invoiceCustomer": "Facturar al cliente",
  "methodCard": "Tarjeta",
  "methodInvoice": "Factura",
  "methodCardHint": "Abre Stripe Checkout para capturar una tarjeta. Stripe la cobra cada periodo y el cliente la gestiona.",
  "methodInvoiceHint": "Stripe envía una factura cada periodo con plazos netos. No se captura tarjeta.",
  "billingEmail": "Correo de facturación",
  "billingEmailHint": "Donde Stripe envía facturas y recibos.",
  "billingEmailPlaceholder": "cuentas@cliente.com.au",
  "invoiceDueDays": "Vencimiento de factura (días)",
  "setupFailed": "No se pudo configurar la facturación",
  "continueToStripe": "Continuar a Stripe",
  "createSubscription": "Crear suscripción",
  "subscriptionCreated": "Suscripción creada. Stripe enviará las facturas a {{email}}.",
  "cancelTitle": "Cancelar al final del periodo",
  "cancelBody": "La suscripción sigue activa hasta el final del periodo actual y luego no se renovará.",
  "cancelBodyDetailed": "La facturación se detiene al final del periodo pagado{{onDate}}. Las firmas se siguen estampando hasta entonces, y hoy no hay reembolso ni cargo.",
  "cancelOnDate": " el {{date}}",
  "confirmCancel": "Confirmar cancelación",
  "resumeBody": "La suscripción se renovará con normalidad otra vez.",
  "updateFailed": "No se pudo actualizar la suscripción",
  "resumedToast": "Suscripción reanudada.",
  "cancelScheduledToast": "La suscripción terminará al final del periodo.",
  "paymentOverdueTitle": "Pago atrasado",
  "paymentOverdueBody": "Stripe no ha podido cobrar la última factura. Las firmas se siguen estampando — nada se detiene solo — pero la cuenta necesita atención.",
  "scheduledCancelTitle": "Cancelación programada",
  "scheduledCancelBody": "Esta suscripción termina el {{date}} y no se renovará.",
  "scheduledCancelFallbackDate": "el final del periodo actual",
  "billingLabel": "Facturación",
  "invoicesGoTo": "Las facturas van a",
  "notSet": "Sin definir",
  "price": "Precio",
  "ends": "Termina",
  "renews": "Se renueva",
  "seatsLastSynced": "Última sincronización de asientos",
  "manage": "Gestionar",
  "manageHint": "Tarjetas, facturas y recibos viven en Stripe. Los asientos se concilian aquí cada noche, y un cambio entra en vigor en la siguiente factura, no a mitad de esta.",
  "mspOnlyHint": "Cambiar o cancelar la suscripción lo hacen el personal de OnBrand Mail."
}
